import { atom } from "recoil"

export const addressState = atom({
  key: "address",
  default: "",
})
